<template>
    <div class="cadre">
        <h3>Zone de stockage</h3>
        <table>
            <thead>
                <tr>
                    <th>Libellé</th>
                    <th>
                        <div class="tab_outils">
                            <div>
                                <a data-bs-toggle="modal" data-bs-target="#modalEditZoneStockage"
                                    v-on:click="editZoneStockage(null)">
                                    <i class="material-icons"
                                        style="font-size:20px;color:black; display: flex;justify-content: flex-end">add_circle</i>
                                </a>
                            </div>
                        </div>
                    </th>
                </tr>

            </thead>
            <tbody>
                <tr v-for="(zoneStockage, index) in zoneStockages" :key="zoneStockage.id">
                    <td>{{ zoneStockage.libelle }}</td>
                    <td>
                        <div class="tab_outils">
                            <div>
                                <a data-bs-toggle="modal" data-bs-target="#modalEditZoneStockage"
                                v-on:click="editZoneStockage(zoneStockage.id)">
                                    <i class="material-icons" style="font-size:20px;color:black">edit</i>
                                </a>
                            </div>
                            <div>
                                <a v-on:click="deleteZoneStockage(index)">
                                    <i class="material-icons" style="font-size:20px;color:red">delete</i>
                                </a>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <ZoneStockageEdit :params="{ id: zoneStockageId }" @saved="fetchZoneStockage" />

</template>

<script>
import Axios from '@/services/axios.service';
import ZoneStockageEdit from './ZoneStockageEdit.vue';

export default {
    name: 'ZoneStockageIndex',
    components: {
        ZoneStockageEdit,
    },
    data() {
        return {
            zoneStockages: [],
            zoneStockageId: null,
        };
    },
    props: {
        msg: String
    },
    mounted() {
        this.fetchZoneStockage();
    },
    methods: {
        fetchZoneStockage() {
            Axios.get('/zoneStockage/statut/ACTIF')
                .then(res => {
                    this.zoneStockages = res.data;
                })
                .catch(err => {
                    console.error('Erreur lors du chargement des zone de stockage :', err);
                });
        },
        deleteZoneStockage(index) {
            Axios.delete('/zoneStockage/' + this.zoneStockages[index].id)
                .then(response => {
                    if (response.status == 200) {
                        this.zoneStockages.splice(index, 1)
                    }
                })
                .catch(err => {
                    alert(err)
                })
        },
        editZoneStockage(id) {
            this.zoneStockageId = id;
        },
    }
}
</script>

<style></style>